// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner-wrapper{display:flex;align-items:center;margin-top:30px}.spinner-wrapper .spinner{margin:0 auto}.spinner-wrapper .spinner,.spinner-wrapper .ui-icon,.spinner-wrapper .ui-icon svg{width:45px;height:45px;fill:#3CD1BF}.spinner{animation-name:rotate;animation-duration:0.4s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes rotate{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}\n", ""]);
// Exports
module.exports = exports;
